import ApplicationSubmissionSection from "../components/partnership/ApplicationSubmissionSection";
import HeroSection from "../components/partnership/HeroSection";
import Process from "../components/partnership/Process";
import WhatYouGet from "../components/partnership/WhatYouGet";

const PartnershipPage = ({ openModal }) => {
  return (
    <main>
      <HeroSection openModal={openModal} />
      <WhatYouGet />
      <Process />
      <ApplicationSubmissionSection openModal={openModal} />
    </main>
  );
};

export default PartnershipPage;
